import { Collection } from 'modules/core/lib/mobx-rest'

import Field from 'modules/reports/store/models/Field'

class Fields extends Collection<Field> {
  get cacheKey(): string {
    return 'fields'
  }

  model() {
    return Field
  }

  // FIXME: This needs investigation. Since last versions of mobx, mobx indexes
  // started to crash for this collection. This forced us to define the
  // primaryKey in the collection rather than in the model, going against
  // mobx-rest documentation.
  get primaryKey(): string {
    return 'path'
  }

  findByPath(path: string): Field | null | undefined {
    return this.models.find((f: Field) => path === f.attributes.path)
  }
}

const singleton: Fields = new Fields()

export default singleton
